import React, { useEffect, useState, useCallback } from 'react'
import FeaturedSchoolFiltersView from './FeaturedSchoolFiltersView'
import debounce from 'lodash.debounce'

const FeaturedSchoolFilters = (props) => {
    const { user, handleFilterChange, schoolCount, setFilters, filters, urlFilters, selectedLocationTag, searchableCityList } = props
    const [searchCities, setSearchCities] = useState([])
    const [isLoaded, setIsLoaded] = useState(false)
    const [citiesInput, setCitiesInput] = useState('')
    const [showFeaturedSchoolFiltersModal, setShowFeaturedSchoolFiltersModal] = useState(false)

    useEffect(() => {
        initializeSetupState()
    }, [])

    useEffect(() => {
        if (isLoaded) {
            handleFilterChange(filters)
        }
    }, [filters.province, filters.studyDomain, filters.freeText])

    const initializeSetupState = () => {
        const initializedFilters = initializeState()

        setFilters(initializedFilters)
        setSearchCities(searchableCityList)
        setIsLoaded(true)
    }

    const initializeState = (reset) => {
        let searchField = {
            title: '',
            studyDomain: [],
            province: [],
            page: 1
        }

        if (!reset && urlFilters) {
            searchField = {
                ...searchField,
                ...urlFilters
            }
        }

        setFilters(searchField)

        return searchField
    }

    const reset = () => {
        const newFilters = initializeState(true)
        handleFilterChange(newFilters)
        window.history.pushState('', '', location.pathname)
    }

    const debouncedFilterChange = useCallback(
        debounce(handleFilterChange, 1000), []
    )

    return (
        <>
            {isLoaded &&
                <FeaturedSchoolFiltersView
                    debouncedFilterChange={debouncedFilterChange}
                    schoolCount={schoolCount}
                    searchCities={searchCities}
                    citiesInput={citiesInput}
                    setSearchCities={setSearchCities}
                    setCitiesInput={setCitiesInput}
                    setFilters={setFilters}
                    filters={filters}
                    selectedLocationTag={selectedLocationTag}
                    handleFilterChange={handleFilterChange}
                    showFeaturedSchoolFiltersModal={showFeaturedSchoolFiltersModal}
                    setShowFeaturedSchoolFiltersModal={setShowFeaturedSchoolFiltersModal}
                    reset={reset}
                    user={user}
                />
            }
        </>
    )
}

export default FeaturedSchoolFilters
